
import { Vue, Options } from "vue-class-component";

@Options({
  name: "PremiumHeader",
  props: {
    daysRemaining: {
      type: Object,
    },
    isYearlyPlan: {
      type: Boolean,
    },
  },
})
export default class PremiumHeader extends Vue {
  private readonly daysRemaining!: {
    days: number;
    hours: number;
    minutes: number;
  };
  private readonly isYearlyPlan!: boolean;

  protected get header(): string {
    const { days, hours, minutes } = this.daysRemaining;

    if (this.isYearlyPlan) {
      if (days === 0 && (hours > 0 || minutes > 0)) {
        return this.$t("premium.header.today") as string;
      }

      if (days > 0) {
        const dayLabelKey = days === 1 ? "premium.labels.day" : "premium.labels.days";
        const dayLabel = this.$t(dayLabelKey);
        return this.$t("premium.header.days", { days, dayLabel }) as string;
      }
    }

    return this.$t("premium.header.ended") as string;
  }
}
